import React, { useState, useCallback, useMemo, useEffect, useRef, useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import "../Components/TreatmentPage/MedicalTreatment.css";
import "../Components/TreatmentPage/MedicalTreatmentNew.css";

import Sidebar from "../Components/Sidebars/main";
import NavBar from "../Components/Navbars/main";
// import MedicalTreatmentIcon from "../assets/images/medical-treatment-icon.svg";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import SimpleIcon from "../assets/images/simple-icon.svg";
import DetailIcon from "../assets/images/detail.svg";
import ScheduleIcon from "../assets/images/chronology.svg";
import DatesIcon from "../assets/images/dates.svg";
import "./TreatmentPage.css";
import {
  addClickRecord,
  fetchPageObject,
  fetchShakespeareStatus,
  getCaseId,
  getClientId,
} from "../Utils/helper";
// import TreatmentTabs from "../Components/TreatmentPage/TreatmentTabs";
import AddNewProvider from "../Components/TreatmentPage/modals/AddNewProvider";
import { api_without_cancellation } from "../api/api";
import {
  useGetCaseProviders,
  useGetCaseSpecialities,
  useGetHipaaStatus,
  useGetTreatmentDates,
  // useGetTreatmentDates,
  useGetTreatmentDetailsPageData,
} from "../Components/TreatmentPage/hooks/useApiResource";
// import { useGetTreatmentDatesWithConsolidation } from "../Components/TreatmentPage/hooks/useGetTreatmentData";
// import SpecialtyFilters from "../Components/TreatmentPage/components/SpecialityFilters";
import TreatmentFooter from "../Components/TreatmentPage/components/treatmentFooter";
import TreatmentDatesModal from "../Components/TreatmentPage/treatment-dates-modal/treatmentDatesModal";
import ClientProvidersStyles from "../Components/CaseDashboard/ClientProvidersStyles";
import PhotoTab from "../Components/new-client-dashboard/tabs/photo-tab/photo";
import ResponsiveTabWrapper from "../Components/TreatmentPage/components/new/ResponsiveTabWrapper";
import NotesSectionDashboard from "../Components/NotesSectionDashboard/main";
import addIconGold from "../assets/Add-icon-gold.svg";

// eslint-disable-next-line import/no-unresolved
import TreatmentPageSimplePage from "./TreatmentPageSimple2";
// eslint-disable-next-line import/no-unresolved
import TreatmentPageDetailPage from "./TreatmentPageDetailPage";
// eslint-disable-next-line import/no-unresolved
import TreatmentDatesPageTable from "./TreatmentDatesPageTable";
import TreatmentSummaryPage from "./TreatmentSummaryPage";

const Wrapper = styled.div`
  > :first-of-type .CheckListSection {
    top: 25px;
  }
`;

// const Wrapper2 = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(var(--card-w), 1fr));
//   gap: 5px;
//   // margin-right: 5px;

//   > :first-of-type .CheckListSection {
//     top: 25px;
//   }
// `;

const Wrapper2 = styled.div`
  display: grid;
  grid-template-columns: repeat(var(--cols), minmax(var(--card-w), 1fr));
  gap: 5px;
  margin-bottom: 5px;

  > :first-of-type .CheckListSection {
    top: 25px;
  }
`;

const HIPAA_STATUS_POLL_INTERVAL_MS = 8000;
const HIPAA_STATUS_MIN_POLL_ATTEMPTS = 10;
const HIPAA_STATUS_MAX_POLL_ATTEMPTS = 30;
const HIPAA_PENDING_STATES = new Set(["pending", "processing", "queued"]);

const TreatmentPage = () => {
  // redux
  const dispatch = useDispatch();
  // const reduxData = useSelector((state) => state.todos);
  // constants
  const caseID = getCaseId();
  const clientID = getClientId();

  const [HandlePage, setHandlePage] = useState("detail");
  const [activeSpecialty, setActiveSpecialty] = useState("all");

  const [firmName, setFirmName] = useState();
  const [newProviderShow, setNewProviderShow] = useState(false);
  const [treatmentDatesPopUpShow, setTreatmentDatesPopUpShow] = useState(false);
  const [treatmentDateData2, setTreatmentDateData2] = useState([]);
  const [selectedGap, setSelectedGap] = useState("Do not show gaps");
  const [isConsolidated, setIsConsolidated] = useState(true);
  const [visibleDateColumns, setVisibleDateColumns] = useState({
    cpt_codes: true,
    diagnosis_codes: true,
    body_part: true,
  });
  const [dateColumnsSaving, setDateColumnsSaving] = useState(false);

  const { data: caseProvidersList, refetch: refetchCaseP } = useGetCaseProviders();
  const { data: specialitiesList, refetch: refetchSpecial } = useGetCaseSpecialities();
  const {
    data: treatmentDateData,
    refetch: refetchTreatment,
    loading: datesTableLoading,
  } = useGetTreatmentDates();
  const { data, refetch: refetchTreatmentDetails, loading } = useGetTreatmentDetailsPageData();
  const {
    data: hipaaStatus,
    loading: hipaaStatusLoading,
    refetch: refetchHipaaStatus,
  } = useGetHipaaStatus();
  const hipaaRefreshTimeoutRef = useRef(null);
  const hipaaPollingActiveRef = useRef(false);
  const hipaaPollingExhaustedRef = useRef(false);
  const hipaaPollAttemptRef = useRef(0);
  const hipaaPollGenerationRef = useRef(0);
  // const { data: treatmentDateData, refetch: refetchTreatment } =
  //   useGetTreatmentDatesWithConsolidation(isConsolidated);
  const [pageObject, setPageObject] = useState(null);

  React.useEffect(() => {
    if (caseID && !pageObject) {
      fetchPageObject(caseID, 8).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseID, pageObject]);

  const handleSpecialtyChange = (id) => {
    setActiveSpecialty(id);
  };

  useEffect(() => {
    if (treatmentDateData) {
      setTreatmentDateData2(treatmentDateData?.data || []);
      setIsConsolidated(treatmentDateData?.expanded);
      setVisibleDateColumns({
        cpt_codes: treatmentDateData.show_cpt_codes ?? true,
        diagnosis_codes: treatmentDateData.show_diagnosis_codes ?? true,
        body_part: treatmentDateData.show_body_part ?? true,
      });
    }
  }, [treatmentDateData]);

  const handleDateColumnChange = async (key, checked) => {
    if (dateColumnsSaving) return;

    const previousColumns = visibleDateColumns;
    const nextColumns = { ...previousColumns, [key]: checked };
    setVisibleDateColumns(nextColumns);
    setDateColumnsSaving(true);

    try {
      const response = await api_without_cancellation.post(
        `/api/treatment/dates_treatment/${caseID}/`,
        {
          client_id: clientID,
          show_cpt_codes: nextColumns.cpt_codes,
          show_diagnosis_codes: nextColumns.diagnosis_codes,
          show_body_part: nextColumns.body_part,
        }
      );
      setVisibleDateColumns({
        cpt_codes: response.data?.show_cpt_codes ?? nextColumns.cpt_codes,
        diagnosis_codes: response.data?.show_diagnosis_codes ?? nextColumns.diagnosis_codes,
        body_part: response.data?.show_body_part ?? nextColumns.body_part,
      });
      if (Array.isArray(response.data?.data)) {
        setTreatmentDateData2(response.data.data);
      }
      if (typeof response.data?.expanded === "boolean") {
        setIsConsolidated(response.data.expanded);
      }
    } catch {
      setVisibleDateColumns(previousColumns);
    } finally {
      setDateColumnsSaving(false);
    }
  };

  const NewfilteredProviders = useMemo(() => {
    const result = {};
    specialitiesList.forEach((specialty) => {
      if (activeSpecialty === "all" || activeSpecialty === specialty.id) {
        result[specialty.id] = data.filter((provider) => provider.specialty?.id === specialty.id);
      }
    });

    if (activeSpecialty === "all") {
      result["null"] = data.filter((provider) => provider.specialty?.id === null);
    }
    return result;
  }, [specialitiesList, data, activeSpecialty]);

  React.useEffect(() => {
    async function fetchFirmName() {
      try {
        const response = await api_without_cancellation.get(
          `/api/cases/${clientID}/${caseID}/summary/`
        );

        setFirmName(response?.data);
      } catch (error) {
        console.error("Error fetching firm name:", error);
      }
    }

    fetchFirmName();
  }, [caseID, clientID]);

  React.useEffect(() => {
    async function fetchPagePreference() {
      try {
        const response = await api_without_cancellation.get("/api/home/firmuser-preferences/");
        if (response.data?.ProviderFull) {
          setHandlePage("detail");
        } else if (response.data?.ProviderSummary) {
          setHandlePage("summary");
        } else if (response.data?.ProviderSimple) {
          setHandlePage("simple");
        } else if (response.data?.ProviderDates) {
          setHandlePage("dates");
        } else {
          setHandlePage("detail");
        }

        // console.log(response.data, "HandlePage");
      } catch (error) {
        console.error("Error fetching page preference:", error);
      }
    }

    fetchPagePreference();
  }, []);

  React.useEffect(() => {
    fetchShakespeareStatus(caseID, 8, dispatch);
  }, [caseID, clientID, dispatch]);

  const handlePageChange = useCallback((pageType) => {
    setHandlePage(pageType);
  }, []);
  const handleNewProviderShow = useCallback(() => {
    setNewProviderShow(true);
  }, []);

  const handleNewProviderClose = useCallback((shouldRefresh = false) => {
    setNewProviderShow(false);

    if (shouldRefresh === "true") {
      refetchCaseP(true);
      refetchTreatmentDetails(true);
      refetchSpecial(true);
      refetchTreatment(true);
    }
  }, []);

  const handleTreatmentDatesPopUpClose = useCallback(
    (shouldRefresh = false) => {
      setTreatmentDatesPopUpShow(false);

      if (shouldRefresh === "true") {
        refetchCaseP(true);
        refetchTreatmentDetails(true);
        refetchSpecial(true);
        refetchTreatment(true);
      }
    },

    []
  );

  const handleTreatmentDatesPopUpShow = useCallback(() => {
    setTreatmentDatesPopUpShow(true);
  }, []);

  const refetchAll = useCallback(() => {
    try {
      refetchTreatmentDetails(true);
      refetchSpecial(true);
      refetchTreatment(true);
      refetchCaseP(true);
    } catch (error) {
      console.error(error);
    }
  }, [refetchCaseP, refetchSpecial, refetchTreatment, refetchTreatmentDetails]);

  const pollHipaaStatus = useCallback(
    async (pollGeneration) => {
      if (pollGeneration !== hipaaPollGenerationRef.current) return;

      hipaaPollAttemptRef.current += 1;
      try {
        const latestStatus = await refetchHipaaStatus(true);
        if (pollGeneration !== hipaaPollGenerationRef.current) return;

        const providers = Array.isArray(latestStatus?.providers) ? latestStatus.providers : [];
        const hasPendingProvider = providers.some((provider) =>
          HIPAA_PENDING_STATES.has(String(provider?.state || "").toLowerCase())
        );
        const hasCompletedInitialChecks =
          hipaaPollAttemptRef.current >= HIPAA_STATUS_MIN_POLL_ATTEMPTS;
        const shouldContinue =
          !hasCompletedInitialChecks ||
          latestStatus?.has_generic_hipaa !== true ||
          providers.length === 0 ||
          hasPendingProvider;

        if (shouldContinue && hipaaPollAttemptRef.current < HIPAA_STATUS_MAX_POLL_ATTEMPTS) {
          hipaaRefreshTimeoutRef.current = window.setTimeout(
            () => pollHipaaStatus(pollGeneration),
            HIPAA_STATUS_POLL_INTERVAL_MS
          );
          return;
        }

        hipaaPollingActiveRef.current = false;
        hipaaPollingExhaustedRef.current = shouldContinue;
      } catch (error) {
        console.error("Failed to refresh the case HIPAA status:", error);
        if (
          pollGeneration === hipaaPollGenerationRef.current &&
          hipaaPollAttemptRef.current < HIPAA_STATUS_MAX_POLL_ATTEMPTS
        ) {
          hipaaRefreshTimeoutRef.current = window.setTimeout(
            () => pollHipaaStatus(pollGeneration),
            HIPAA_STATUS_POLL_INTERVAL_MS
          );
        } else {
          hipaaPollingActiveRef.current = false;
          hipaaPollingExhaustedRef.current = true;
        }
      }
    },
    [refetchHipaaStatus]
  );

  const startHipaaStatusPolling = useCallback(() => {
    if (hipaaRefreshTimeoutRef.current) {
      window.clearTimeout(hipaaRefreshTimeoutRef.current);
    }

    hipaaPollGenerationRef.current += 1;
    hipaaPollAttemptRef.current = 0;
    hipaaPollingActiveRef.current = true;
    hipaaPollingExhaustedRef.current = false;
    pollHipaaStatus(hipaaPollGenerationRef.current);
  }, [pollHipaaStatus]);

  const handleHipaaDocumentUploaded = useCallback(() => {
    startHipaaStatusPolling();
  }, [startHipaaStatusPolling]);

  useEffect(() => {
    const hasPendingProvider = hipaaStatus?.providers?.some((provider) =>
      HIPAA_PENDING_STATES.has(String(provider?.state || "").toLowerCase())
    );

    if (hasPendingProvider && !hipaaPollingActiveRef.current && !hipaaPollingExhaustedRef.current) {
      startHipaaStatusPolling();
    }
  }, [hipaaStatus, startHipaaStatusPolling]);

  useEffect(
    () => () => {
      hipaaPollGenerationRef.current += 1;
      hipaaPollingActiveRef.current = false;
      if (hipaaRefreshTimeoutRef.current) {
        window.clearTimeout(hipaaRefreshTimeoutRef.current);
      }
    },
    []
  );

  // console.log(HandlePage, "HandlePage Here");

  const tabsData = [
    {
      id: "summary",
      label: "Summary",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-50)",

      onClick: () => {
        addClickRecord(999, 8);
        handlePageChange("summary");
      },
      leftHand: true,
      span: (
        <span
          style={{
            width: "15px",
            height: "15px",
          }}
          className="fw-bold d-flex align-items-center justify-content-center  text-gold"
        >
          <img
            src={DatesIcon}
            style={{
              width: "15px",
              height: "15px",
            }}
            alt="Detail"
          />
        </span>
      ),
    },
    {
      id: "simple",
      label: "Simple",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-50)",

      onClick: () => {
        addClickRecord(999, 8);
        handlePageChange("simple");
      },
      leftHand: true,
      span: (
        <span
          style={{
            width: "15px",
            height: "15px",
          }}
          className="fw-bold d-flex align-items-center justify-content-center text-gold"
        >
          <img
            src={SimpleIcon}
            style={{
              width: "15px",
              height: "15px",
            }}
            alt="Detail"
          />
        </span>
      ),
    },
    {
      id: "treatment",
      label: "Detail",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-50)",

      onClick: () => {
        addClickRecord(999, 8);
        handlePageChange("detail");
      },
      leftHand: true,
      span: (
        <span
          style={{
            width: "15px",
            height: "15px",
          }}
          className="fw-bold d-flex align-items-center justify-content-center text-gold"
        >
          <img
            src={DetailIcon}
            style={{
              width: "15px",
              height: "15px",
            }}
            alt="Detail"
          />
        </span>
      ),
    },
    {
      id: "dates",
      label: "Chronology",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-50)",
      left: "0px",
      onClick: () => {
        addClickRecord(999, 8);
        handlePageChange("dates");
      },
      leftHand: true,
      span: (
        <span
          style={{
            width: "15px",
            height: "15px",
          }}
          className="fw-bold d-flex align-items-center justify-content-center text-gold"
        >
          <img
            src={ScheduleIcon}
            style={{
              width: "15px",
              height: "15px",
            }}
            alt="Detail"
          />
        </span>
      ),
    },

    // {
    //   id: "treatmentDates",
    //   label: "Dates",
    //   className: "tab-trapezium-cycles-corners",
    //   background: "var(--primary-60)",

    //   left: "0px",
    //   onClick: handleTreatmentDatesPopUpShow,
    //   leftHand: true,
    //   span: <span className="fw-bold p-r-5 text-gold">+</span>,
    // },
  ];

  const addTab = [
    {
      id: "newProvider",
      label: "Treatment",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-50)",

      left: "0px",
      onClick: () => {
        addClickRecord(999, 8);
        handleNewProviderShow();
      },
      leftHand: true,
      span: (
        <span className="fw-bold  ic-15 d-flex align-items-center">
          <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
        </span>
      ),
    },
  ];

  const photoTab = [
    {
      id: "photo",
      label: "Photos",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-50)",
      activeColor: "white",

      left: "0px",
      onClick: () => handlePageChange("photo"),
      leftHand: true,
      span: (
        <span
          style={{
            width: "15px",
            height: "15px",
          }}
          className="fw-bold d-flex align-items-center justify-content-center text-gold"
        >
          <img
            src={
              "https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg"
            }
            style={{
              width: "15px",
              height: "15px",
            }}
            alt="Detail"
          />
        </span>
      ),
    },
  ];

  const [maxWidth, setMaxWidth] = useState(225);

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  const [nameWidth, setWidthName] = useState(0);
  const tableRef = useRef(null);
  const effectiveNameWidth = Math.max(nameWidth, maxWidth);
  // Name measurement excludes 10px left + 30px TF padding and its added 10px allowance.
  const namePanelWidth = effectiveNameWidth + 40 + 10;
  const nameAndChecklist = namePanelWidth + 50 + 180;
  const cardWidth = Math.max(Math.ceil(nameAndChecklist), 535);
  const totalCards = useMemo(() => {
    return Object.values(NewfilteredProviders).reduce((sum, arr) => sum + (arr?.length ?? 0), 0);
  }, [NewfilteredProviders]);

  const GRID_GAP = 5;
  const gridRef = useRef(null);
  const [gridCols, setGridCols] = useState(1);

  useLayoutEffect(() => {
    if (HandlePage !== "simple" || loading) return;
    const el = gridRef.current;
    if (!el) return;
    const container = el.parentElement;
    if (!container) return;

    const calc = () => {
      const width = container.clientWidth;
      if (!width || !totalCards) return;

      const maxCols = Math.max(1, Math.floor((width + GRID_GAP) / (cardWidth + GRID_GAP)));
      setGridCols(Math.min(totalCards, maxCols));
    };

    calc();
    const ro = new ResizeObserver(calc);
    ro.observe(container);
    return () => ro.disconnect();
  }, [HandlePage, loading, totalCards, cardWidth]);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName="8" />
          <ActionBarComponent
            src={pageObject?.page_icon}
            page_name={pageObject?.name}
            pageObj={pageObject}
            buttons={[]}
            isChecklist={pageObject?.PageChklst || false}
          />
          <div className="TreatmentPage-main-container invisible-scrollbar">
            <ResponsiveTabWrapper
              specialitiesList={specialitiesList}
              activeSpecialty={activeSpecialty}
              onSpecialtyChange={handleSpecialtyChange}
              HandlePage={HandlePage}
              tabsData={tabsData}
              addTab={addTab}
              photoTab={photoTab}
              setMaxWidth={setMaxWidth}
              handlePageChange={handlePageChange}
              handleNewProviderShow={handleNewProviderShow}
            />
            {loading ? (
              <Box sx={{ width: "100%", paddingTop: "15px" }}>
                <LinearProgress
                  sx={{
                    backgroundColor: "#8C9AAF", // Background track color
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: "#19395f", // Progress bar color
                    },
                  }}
                />
              </Box>
            ) : (
              <div
                style={{
                  height: "calc(100% - 25px)",
                }}
              >
                <ClientProvidersStyles
                  clientProviders={[
                    {
                      specialty: {
                        ...specialitiesList,
                      },
                    },
                  ]}
                />
                {HandlePage === "detail" ? (
                  <Wrapper>
                    {specialitiesList.map((specialitie) =>
                      NewfilteredProviders[specialitie.id]?.map((caseProvider) => (
                        <TreatmentPageDetailPage
                          key={caseProvider?.id}
                          caseProvider={caseProvider}
                          specialitiesList={specialitie}
                          firmName={firmName}
                          refetchAll={refetchAll}
                          refetchTreatment={refetchTreatment}
                          handleTreatmentDatesPopUpShow={handleTreatmentDatesPopUpShow}
                          maxWidth={maxWidth}
                          treatmentDateData={treatmentDateData?.data}
                          hipaaStatus={hipaaStatus}
                          hipaaStatusLoading={hipaaStatusLoading}
                          onHipaaDocumentUploaded={handleHipaaDocumentUploaded}
                        />
                      ))
                    )}

                    {NewfilteredProviders["null"]?.map((caseProvider) => (
                      <TreatmentPageDetailPage
                        key={caseProvider?.id}
                        caseProvider={caseProvider}
                        specialitiesList={{
                          id: "null",
                          name: "",
                          color: "#19395f",
                          secondary_color: "#75889f",
                        }}
                        firmName={firmName}
                        refetchAll={refetchAll}
                        refetchTreatment={refetchTreatment}
                        maxWidth={maxWidth}
                        treatmentDateData={treatmentDateData?.data}
                        hipaaStatus={hipaaStatus}
                        hipaaStatusLoading={hipaaStatusLoading}
                        onHipaaDocumentUploaded={handleHipaaDocumentUploaded}
                      />
                    ))}
                  </Wrapper>
                ) : HandlePage === "simple" ? (
                  <>
                    <Wrapper2
                      ref={gridRef}
                      style={{ "--card-w": `${cardWidth}px`, "--cols": gridCols }}
                    >
                      {specialitiesList.map((specialitie) =>
                        NewfilteredProviders[specialitie.id]?.map((caseProvider) => (
                          <TreatmentPageSimplePage
                            key={caseProvider?.id}
                            caseProvider={caseProvider}
                            specialitiesList={specialitie}
                            firmName={firmName}
                            refetchAll={refetchAll}
                            maxWidth={maxWidth}
                            treatmentDateData={treatmentDateData?.data}
                            tableRef={tableRef}
                            setWidthName={setWidthName}
                          />
                        ))
                      )}

                      {NewfilteredProviders["null"]?.map((caseProvider) => (
                        <TreatmentPageSimplePage
                          key={caseProvider?.id}
                          caseProvider={caseProvider}
                          specialitiesList={{
                            id: "null",
                            name: "",
                            color: "#19395f",
                            secondary_color: "#75889f",
                          }}
                          firmName={firmName}
                          refetchAll={refetchAll}
                          maxWidth={maxWidth}
                          treatmentDateData={treatmentDateData?.data}
                          tableRef={tableRef}
                          setWidthName={setWidthName}
                        />
                      ))}
                    </Wrapper2>
                  </>
                ) : HandlePage === "summary" ? (
                  <>
                    <TreatmentSummaryPage
                      firmName={firmName}
                      refetchAll={refetchAll}
                      maxWidth={maxWidth}
                      treatmentDateData={treatmentDateData?.data}
                      tableRef={tableRef}
                      setWidthName={setWidthName}
                      providers={data}
                      activeSpecialty={activeSpecialty}
                    />
                  </>
                ) : HandlePage === "dates" ? (
                  <>
                    <TreatmentDatesPageTable
                      treatmentDateData={treatmentDateData2}
                      setTreatmentDateData2={setTreatmentDateData2}
                      activeSpecialty={activeSpecialty}
                      refetchTreatment={refetchTreatment}
                      selectedGap={selectedGap}
                      setSelectedGap={setSelectedGap}
                      caseProvider={caseProvidersList}
                      specialitie={specialitiesList}
                      isConsolidated={isConsolidated}
                      setIsConsolidated={setIsConsolidated}
                      datesTableLoading={datesTableLoading}
                      visibleColumns={visibleDateColumns}
                      onColumnChange={handleDateColumnChange}
                      columnsSaving={dateColumnsSaving}
                    />
                  </>
                ) : HandlePage === "photo" ? (
                  <>
                    <PhotoTab pageId={8} pageName={"Treatment"} />
                  </>
                ) : null}
                {["detail", "simple", "summary"].includes(HandlePage) && (
                  <NotesSectionDashboard pageName={"Notes"} />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {newProviderShow && (
        <AddNewProvider
          show={newProviderShow}
          handleClose={() => {
            addClickRecord(999, 8);
            handleNewProviderClose("true");
          }}
          firmName={firmName}
          caseProvider={caseProvidersList}
          specialitie={specialitiesList}
        />
      )}

      {treatmentDatesPopUpShow && (
        <TreatmentDatesModal
          show={treatmentDatesPopUpShow}
          handleClose={() => {
            addClickRecord(999, 8);
            handleTreatmentDatesPopUpClose();
          }}
          // firmName={firmName}
          caseProvider={caseProvidersList}
          specialitie={specialitiesList}
          firmName={firmName}
        />
      )}

      <TreatmentFooter />
    </>
  );
};

export default React.memo(TreatmentPage);
